import axios from '@/plugins/axios';

export const fileSubmissionUploadService = {
    async presign(activityId, file) {
        const response = await axios.post('/api/file-submissions/presigned-url', {
            activity_id: activityId,
            file_name: file.name,
            file_size: file.size,
            file_type: file.type,
        });
        if (!response.data.success) {
            throw new Error(response.data.error || 'Failed to generate upload URL');
        }
        return response.data.data;
    },
};
